import { useCallback } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { PROJECTS_ROUTE } from '../../../constants';

export interface ILeaveProjectParams {
  navigate: NavigateFunction;
}

/**
 * Уход к списку проектов.
 *
 * Сохранение несохранённого и очистка проекта тут НЕ живут: этим владеет сама страница
 * редактора (`useLeaveEditorPage`), иначе браузерный «назад» и прямой ввод URL уходили бы
 * мимо (WSL-14). Здесь остаётся только навигация — общая точка для всех мест, откуда
 * уходят к списку.
 */
export function leaveProject({ navigate }: ILeaveProjectParams) {
  navigate(PROJECTS_ROUTE);
}

export function useLeaveProject() {
  const navigate = useNavigate();

  return useCallback(() => leaveProject({ navigate }), [navigate]);
}
